<template>
  <div class="flex flex-row gap-2 flex-wrap justify-center proxima_nova w-full">
    <div v-for="(card, index) in cards" :key="card.id || card.type || index" class="pricing-card">
      <span class="text-sm text_color font-semibold mr-4 card-text">{{ card.label }}</span>
      <span class="card-value mr-1">{{ card.credits }}</span>
      <span class="text-[13px] text_color font-normal card-text">{{ card.period }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  phoneNumberInventory: {
    type: Array,
    default: () => [],
  },
});

const cards = computed(() => {
  if (!props.phoneNumberInventory || props.phoneNumberInventory.length === 0) {
    return [];
  }
  return props.phoneNumberInventory.map((item) => {
    let label = item.type || '';

    if (label === 'Toll-Free' || label === 'Toll Free') {
      label = 'Toll-free Phone Number';
    } else if (label === 'Local') {
      label = 'Local Phone Number';
    } else {
      label = label + ' Phone Number';
    }
    const typeKey = item.type?.toLowerCase().replace(/\s+/g, '-').replace(/-+/g, '-') || '';

    return {
      id: item.id,
      type: typeKey,
      label: label,
      credits: item.credits_per_month || 0,
      period: 'credits/month',
    };
  });
});
</script>

<style scoped>
.pricing-card {
  display: flex;
  max-height: 48px;
  flex-direction: row;
  padding: 12px;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: var(--white-opacity-6);
  white-space: nowrap;
  width: fit-content;
}

.card-text {
  line-height: 1;
  display: flex;
  align-items: center;
}

.card-value {
  font-size: 18px;
  font-weight: 600;
  line-height: 1;
  color: #b343cb;
  background: linear-gradient(95deg, #b343cb -37.89%, #7095eb 127.94%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: flex;
  align-items: center;
}
</style>
